const admin = {
  // ==================== ADMIN VIEW ====================
  'admin.title': 'Administrator-Bereich',
  'admin.back': 'Zurück',
  'admin.tabSettings': 'Einstellungen',
  'admin.tabUsers': 'Benutzer',
  'admin.tabRoles': 'Rollen',
  'admin.tabOciShops': 'OCI-Shops',
  'admin.tabInternalShops': 'Interne Shops',
  'admin.tabMapping': 'Mapping',
  'admin.tabApplication': 'Anwendung',
  'admin.tabAdapter': 'SAP-Adapter',
  'admin.tabAbAdapter': 'AB: Z-REST vs. SOAP',
  'admin.tabSapConnectivity': 'SAP-Konnektivitaet',

  // ==================== ADMIN SAP-ADAPTER TEST PANEL ====================
  'admin.adapter.intro': 'Interne Diagnose gegen den SAP-Adapter (SBX) — kein Kunden-Feature.',
  'admin.adapter.pingTitle': 'Konnektivität (Ping)',
  'admin.adapter.pingButton': 'Ping senden',
  'admin.adapter.readTitle': 'BANF lesen (BAPI_PR_GETDETAIL)',
  'admin.adapter.readButton': 'BANF lesen',
  'admin.adapter.createTitle': 'BANF anlegen — Dry-Run (BAPI_PR_CREATE)',
  'admin.adapter.createHint': 'TESTRUN ist serverseitig fest verdrahtet — legt nie eine echte BANF an.',
  'admin.adapter.createButton': 'Dry-Run ausführen',
  'admin.adapter.resultTitle': 'Ergebnis',
  'admin.adapter.success': 'Anfrage erfolgreich.',
  'admin.adapter.error': 'Anfrage fehlgeschlagen.',
  'admin.adapter.realTitle': 'BANF ECHT anlegen (kein Undo)',
  'admin.adapter.realHint': 'Kein TESTRUN — legt eine echte, dauerhafte BANF in SAP an (BAPI_PR_CREATE + COMMIT).',
  'admin.adapter.realButton': 'Echte BANF anlegen',
  'admin.adapter.realArmedWarning': 'Sicher? Das kann nicht rückgängig gemacht werden.',
  'admin.adapter.realConfirmButton': 'Ja, jetzt wirklich anlegen',
  'admin.adapter.realCancelButton': 'Abbrechen',
  'admin.adapter.deleteTitle': 'BANF löschen/rückgängig machen',
  'admin.adapter.deleteHint': 'Setzt/entfernt nur das Löschkennzeichen (BAPI_PR_CHANGE) — reversibel, im Gegensatz zum Anlegen.',
  'admin.adapter.deleteDryRunButton': 'Dry-Run (Vorschau, schreibt nichts)',
  'admin.adapter.deleteButton': 'BANF-Position löschen',
  'admin.adapter.deleteArmedWarning': 'Sicher?',
  'admin.adapter.deleteConfirmButton': 'Ja, jetzt löschen',
  'admin.adapter.deleteCancelButton': 'Abbrechen',

  // ==================== ADMIN AB-ADAPTER COMPARE PANEL (Z-REST vs. SOAP POC) ====================
  'admin.abAdapter.intro': 'AB-Modul (Auftragsbestaetigung) POC: Z-REST- und SOAP-Publikationsweg gegen dieselben SBX-Daten vergleichen — rein lesend, keine Auftragsbestaetigung hier.',
  'admin.abAdapter.modeTitle': 'Publikationsweg',
  'admin.abAdapter.modeZRest': 'Z-REST',
  'admin.abAdapter.modeSoap': 'SOAP',
  'admin.abAdapter.pingTitle': 'Konnektivitaet (Ping)',
  'admin.abAdapter.pingButton': 'Ping senden',
  'admin.abAdapter.readTitle': 'Offene Bestellpositionen lesen (nur lesend)',
  'admin.abAdapter.readButton': 'Bestellung lesen',
  'admin.abAdapter.resultTitle': 'Ergebnis',
  'admin.abAdapter.success': 'Anfrage erfolgreich.',
  'admin.abAdapter.error': 'Anfrage fehlgeschlagen.',

  // ==================== ADMIN SAP-KONNEKTIVITAET (Kunde/System/Verbindung) ====================
  'admin.sapConnectivity.intro': 'DB-gestuetzte SAP-Konnektivitaetskonfiguration — Kunde, System (Umgebung) und Verbindung (Transportart) statt verstreuter ENV-Variablen.',
  'admin.sapConnectivity.success': 'Gespeichert.',
  'admin.sapConnectivity.error': 'Anfrage fehlgeschlagen.',
  'admin.sapConnectivity.newCustomerTitle': 'Kunde anlegen',
  'admin.sapConnectivity.customerCode': 'Kundencode',
  'admin.sapConnectivity.customerName': 'Kundenname',
  'admin.sapConnectivity.contactName': 'Kontaktperson',
  'admin.sapConnectivity.contactEmail': 'Kontakt-E-Mail',
  'admin.sapConnectivity.contactPhone': 'Kontakt-Telefon',
  'admin.sapConnectivity.addCustomerButton': 'Kunde anlegen',
  'admin.sapConnectivity.customersTitle': 'Kunden',
  'admin.sapConnectivity.noCustomers': 'Noch keine Kunden angelegt.',
  'admin.sapConnectivity.environment': 'Umgebung',
  'admin.sapConnectivity.mandant': 'SAP-Mandant',
  'admin.sapConnectivity.addSystemButton': 'System anlegen',
  'admin.sapConnectivity.connectionType': 'Transportart',
  'admin.sapConnectivity.baseUrl': 'Basis-URL (intern)',
  'admin.sapConnectivity.publicUrl': 'Oeffentliche URL (optional)',
  'admin.sapConnectivity.technicalUser': 'Technischer Benutzer',
  'admin.sapConnectivity.credentialRef': 'Credential-Referenz (ENV-Var-Name)',
  'admin.sapConnectivity.password': 'Passwort (verschluesselt gespeichert)',
  'admin.sapConnectivity.passwordHint': 'Optional — entweder eine Credential-Referenz (ENV-Var-Name) oder hier ein Passwort (verschluesselt at rest, AES-256-GCM). Sind beide gesetzt, gewinnt das gespeicherte Passwort.',
  'admin.sapConnectivity.passwordStored': 'Passwort hinterlegt',
  'admin.sapConnectivity.addConnectionButton': 'Verbindung anlegen',
  'admin.sapConnectivity.testButton': 'Verbindung testen',
  'admin.sapConnectivity.default': 'Standard',

  // ==================== ADMIN GENERAL SETTINGS ====================
  'admin.settings.title': 'Allgemeine Einstellungen',
  'admin.settings.saved': 'Einstellungen erfolgreich gespeichert!',
  'admin.settings.saveError': 'Fehler beim Speichern der Einstellungen',

  // ==================== ADMIN LOGO SETTINGS ====================
  'admin.logo.title': 'Logo',
  'admin.logo.maxSize': 'Das Logo darf nicht größer als 2MB sein.',
  'admin.logo.select': 'Logo auswählen',
  'admin.logo.formats': 'Unterstützte Formate: PNG, JPG, GIF (max. 2MB)',

  // ==================== ADMIN SMTP SETTINGS ====================
  'admin.smtp.title': 'SMTP-Einstellungen',
  'admin.smtp.server': 'SMTP-Server',
  'admin.smtp.username': 'Benutzername',
  'admin.smtp.password': 'Passwort',
  'admin.smtp.senderEmail': 'Absender-E-Mail',
  'admin.smtp.tls': 'Sichere Verbindung (TLS/SSL) verwenden',
  'admin.smtp.notificationsEnabled': 'E-Mail-Benachrichtigungen aktiviert',
  'admin.smtp.notificationsDisabled': 'E-Mail-Benachrichtigungen sind deaktiviert!',
  'admin.smtp.notificationsHint': 'Wenn deaktiviert, werden keine automatischen E-Mails für BANF-Anfragen oder Status-Updates versendet',
  'admin.smtp.testConnection': 'SMTP-Verbindung testen',
  'admin.smtp.testEmail': 'Test-E-Mail senden',
  'admin.smtp.testing': 'Test läuft...',
  'admin.smtp.testSuccess': 'SMTP-Verbindung erfolgreich getestet! Test-E-Mail gesendet an: {email}',
  'admin.smtp.testFailed': 'SMTP-Test fehlgeschlagen',
  'admin.smtp.testFailedMsg': 'SMTP-Test fehlgeschlagen: {error}',
  'admin.smtp.emailSuccess': 'Test-E-Mail erfolgreich an {email} gesendet!',
  'admin.smtp.emailFailed': 'Test-E-Mail fehlgeschlagen',
  'admin.smtp.emailFailedMsg': 'Test-E-Mail fehlgeschlagen: {error}',
  'admin.smtp.hint': 'SMTP-Einstellungen werden für E-Mail-Benachrichtigungen verwendet (z.B. BANF-Bestätigungen, Passwort-Reset)',

  // ==================== ADMIN WEBSITE SETTINGS ====================
  'admin.website.title': 'Website-Einstellungen',
  'admin.website.siteTitle': 'Seitentitel',
  'admin.website.siteTitleHint': 'Wird im Browser-Tab und als Haupttitel angezeigt',

  // ==================== ADMIN LICENSE SETTINGS ====================
  'admin.license.title': 'Lizenzschlüssel',
  'admin.license.softwareLicense': 'Software-Lizenzschlüssel',
  'admin.license.enter': 'Lizenzschlüssel eingeben...',
  'admin.license.enterHint': 'Geben Sie Ihren Lizenzschlüssel ein um erweiterte Funktionen freizuschalten',
  'admin.license.check': 'Lizenz prüfen',
  'admin.license.checking': 'Prüfen...',
  'admin.license.valid': 'Lizenzprüfung erfolgreich',
  'admin.license.empty': 'Bitte geben Sie einen Lizenzschlüssel ein',
  'admin.license.error': 'Fehler bei der Lizenzprüfung',
  'admin.license.autoError': 'Fehler bei der automatischen Lizenzprüfung',
  'admin.license.failed': 'Lizenzprüfung fehlgeschlagen: {error}',
  'admin.license.autoSaveError': 'Fehler beim automatischen Speichern der Lizenzeinstellungen',
  'admin.license.licensedProduct': 'Lizensiertes Produkt: {scope}',
  'admin.license.info': 'Mit einem gültigen Lizenzschlüssel erhalten Sie Zugang zu erweiterten Funktionen und Premium-Support.',
  'admin.license.updateTitle': 'Softwareaktualisierung',
  'admin.license.currentVersion': 'Aktuelle Version: 0.0.1',
  'admin.license.checkUpdates': 'Nach Updates suchen',
  'admin.license.checkingUpdates': 'Suche nach Updates...',
  'admin.license.upToDate': 'Ihre Software ist auf dem neuesten Stand',
  'admin.license.lastChecked': 'Zuletzt geprüft: {date}',
  'admin.license.updateAvailable': 'Update verfügbar: Version 1.1.0',
  'admin.license.updateChanges': 'Neue Funktionen und Fehlerbehebungen',
  'admin.license.install': 'Installieren',
  'admin.license.updateHint': 'Klicken Sie auf den Button um nach verfügbaren Aktualisierungen zu suchen.',

  // ==================== ADMIN MAPPING SETTINGS ====================
  'admin.mapping.title': 'Feld-Zuordnungen',
  'admin.mapping.subtitle': 'Verknüpfung zwischen Code und Bezeichnung',
  'admin.mapping.sapSyncFuture': 'SAP-Synchronisation wird in einer zukünftigen Version verfügbar sein.',
  'admin.mapping.costCenters': 'Kostenstellen',
  'admin.mapping.costCenterCode': 'Kostenstelle',
  'admin.mapping.costCenterLabel': 'Kostenstellenbezeichnung',
  'admin.mapping.plants': 'Werke',
  'admin.mapping.plantCode': 'Werk',
  'admin.mapping.plantLabel': 'Werksbezeichnung',
  'admin.mapping.purchasingOrgs': 'Einkäuferorganisationen',
  'admin.mapping.purchasingOrgCode': 'Einkäuferorganisation',
  'admin.mapping.purchasingOrgLabel': 'Organisationsbezeichnung',
  'admin.mapping.purchasingGroups': 'Einkäufergruppen',
  'admin.mapping.purchasingGroupCode': 'Einkäufergruppe',
  'admin.mapping.purchasingGroupLabel': 'Gruppenbezeichnung',
  'admin.mapping.loadError': 'Fehler beim Laden der {type}',
  'admin.mapping.fillBothFields': 'Bitte füllen Sie beide Felder aus',
  'admin.mapping.alreadyExists': 'Diese {type} existiert bereits',
  'admin.mapping.added': 'Zuordnung erfolgreich hinzugefügt',
  'admin.mapping.addError': 'Fehler beim Speichern der Zuordnung',
  'admin.mapping.updated': 'Zuordnung erfolgreich aktualisiert',
  'admin.mapping.updateError': 'Fehler beim Aktualisieren der Zuordnung',
  'admin.mapping.deleteConfirm': 'Möchten Sie diese Zuordnung wirklich löschen?',
  'admin.mapping.deleted': 'Zuordnung erfolgreich gelöscht',
  'admin.mapping.deleteError': 'Fehler beim Löschen der Zuordnung',
  'admin.mapping.glAccounts': 'Sachkonten',
  'admin.mapping.glAccountCode': 'Sachkonto',
  'admin.mapping.glAccountLabel': 'Sachkontobezeichnung',
  'admin.mapping.orders': 'Innenaufträge',
  'admin.mapping.orderCode': 'Innenauftrag',
  'admin.mapping.orderLabel': 'Auftragsbezeichnung',
  'admin.mapping.syncSap': 'SAP synchronisieren',
  'admin.mapping.refresh': 'Aktualisieren',
  'admin.mapping.addNew': 'Neue {type} hinzufügen',
  'admin.mapping.existing': 'Vorhandene {type} ({count})',
  'admin.mapping.empty': 'Noch keine {type} vorhanden',
  'admin.mapping.emptyHint': 'Fügen Sie oben eine neue Zuordnung hinzu',

  // ==================== ADMIN PERMISSION PROFILES ====================
  'admin.permissions.title': 'Berechtigungsprofile',
  'admin.permissions.subtitle': 'Erstellen Sie Profile als Vorlagen für Benutzerberechtigungen',
  'admin.permissions.newProfile': 'Neues Profil',
  'admin.permissions.empty': 'Noch keine Berechtigungsprofile erstellt',
  'admin.permissions.createFirst': 'Erstes Profil erstellen',
  'admin.permissions.hint': 'Hinweis:',
  'admin.permissions.hintText': 'Änderungen an Profilen wirken sich sofort auf alle zugewiesenen Benutzer aus. Die effektive Berechtigung eines Benutzers ergibt sich aus der Vereinigung aller zugewiesenen Profile.',
  'admin.permissions.deleteConfirm': 'Möchten Sie dieses Profil wirklich löschen?',
  'admin.permissions.restrictions': '{count} Einschränkungen',
  'admin.permissions.loadError': 'Fehler beim Laden der Profile',
  'admin.permissions.created': 'Profil erfolgreich erstellt',
  'admin.permissions.updated': 'Profil erfolgreich aktualisiert',
  'admin.permissions.deleted': 'Profil erfolgreich gelöscht',
  'admin.permissions.allowAll': 'Alle erlauben',
  'admin.permissions.tabGeneral': 'Allgemein',
  'admin.permissions.tabOrganization': 'Organisation',
  'admin.permissions.tabCatalogs': 'Kataloge',
  'admin.permissions.tabFeatures': 'Funktionen',
  'admin.permissions.profileName': 'Profilname *',
  'admin.permissions.description': 'Beschreibung (optional)',
  'admin.permissions.maxOrderValue': 'Maximaler Bestellwert',
  'admin.permissions.docTypes': 'Belegarten',
  'admin.permissions.plants': 'Werke',
  'admin.permissions.costCenters': 'Kostenstellen',
  'admin.permissions.purchasingOrgs': 'Einkaufsorganisationen',
  'admin.permissions.purchasingGroups': 'Einkäufergruppen',
  'admin.permissions.internalShops': 'Interne Shops',
  'admin.permissions.ociShops': 'OCI-Shops',
  'admin.permissions.accessProcurement': 'Zugang zu Beschaffung',
  'admin.permissions.accessProcurementDesc': 'Kann das Beschaffungsmodul nutzen',
  'admin.permissions.accessWarehouse': 'Zugang zu Lagerverwaltung',
  'admin.permissions.accessWarehouseDesc': 'Kann das Lagerverwaltungsmodul nutzen',
  'admin.permissions.accessWorkflow': 'Zugang zu Workflow-Editor',
  'admin.permissions.accessWorkflowDesc': 'Kann Workflows erstellen und bearbeiten',
  'admin.permissions.accessEInvoicing': 'Zugang zu E-Invoicing',
  'admin.permissions.accessEInvoicingDesc': 'Kann das E-Invoicing-Modul nutzen',
  'admin.permissions.accessPm': 'Zugang zu Plant Maintenance',
  'admin.permissions.accessPmDesc': 'Kann das Plant-Maintenance-Modul nutzen',
  'admin.permissions.einvoicing': 'E-Invoicing',
  'admin.permissions.pm': 'Plant Maintenance',
  'admin.permissions.orderConfirmation': 'Auftragsbestätigung',
  'admin.permissions.createBanf': 'BANF erstellen',
  'admin.permissions.createBanfDesc': 'Kann Bestellanforderungen erstellen',
  'admin.permissions.approveBanf': 'BANF genehmigen',
  'admin.permissions.approveBanfDesc': 'Kann Bestellanforderungen genehmigen',
  'admin.permissions.manageFavorites': 'Favoriten verwalten',
  'admin.permissions.manageFavoritesDesc': 'Kann persönliche Favoriten speichern',
  'admin.permissions.editCatalog': 'Katalog bearbeiten',
  'admin.permissions.editCatalogDesc': 'Darf interne Katalogprodukte bearbeiten (ohne Admin-Rolle)',
  'admin.permissions.accessOrderConfirmation': 'Auftragsbestätigung erfassen',
  'admin.permissions.accessOrderConfirmationDesc': 'Zugriff auf das Modul Auftragsbestätigung (AB-Upload, OCR-Prüfung, Bestellabgleich)',
  'admin.permissions.procurement': 'Beschaffung',
  'admin.permissions.warehouse': 'Lagerverwaltung',
  'admin.permissions.plantsCount': 'Werke: {value}',
  'admin.permissions.costCentersCount': 'Kostenstellen: {value}',
  'admin.permissions.purchasingOrgsCount': 'EK-Org: {value}',
  'admin.permissions.internalShopsCount': 'Interne Shops: {value}',
  'admin.permissions.ociShopsCount': 'OCI-Shops: {value}',
  'admin.permissions.maxValue': 'Max. Wert: {value}',

  // ==================== ADMIN PASSWORD CHANGE ====================
  'admin.password.title': 'Passwort ändern',
  'admin.password.titleFor': 'Passwort für {username} ändern',
  'admin.password.current': 'Aktuelles Passwort',
  'admin.password.new': 'Neues Passwort',
  'admin.password.confirm': 'Passwort bestätigen',
  'admin.password.mismatch': 'Neue Passwörter stimmen nicht überein',
  'admin.password.minLength': 'Das neue Passwort muss mindestens 6 Zeichen lang sein',
  'admin.password.currentRequired': 'Bitte geben Sie Ihr aktuelles Passwort ein',
  'admin.password.changed': 'Passwort erfolgreich geändert!',
  'admin.password.error': 'Fehler beim Ändern des Passworts',

  // ==================== ADMIN USER MANAGEMENT ====================
  'admin.users.title': 'Benutzerverwaltung',
  'admin.users.subtitle': 'Verwalten Sie System- und OCI-Benutzer',
  'admin.users.localUsers': 'Lokale Benutzer',
  'admin.users.ociUsers': 'OCI-Benutzer',
  'admin.users.newOciUser': 'Neuer OCI-Benutzer',
  'admin.users.search': 'Benutzer suchen...',
  'admin.users.filterAll': 'Alle Benutzer',
  'admin.users.filterActive': 'Nur aktive',
  'admin.users.filterInactive': 'Nur inaktive',
  'admin.users.loading': 'Benutzer werden geladen...',
  'admin.users.ociLoading': 'OCI-Benutzer werden geladen...',
  'admin.users.usernamePasswordRequired': 'Benutzername und Passwort sind erforderlich',
  'admin.users.noUsersFound': 'Keine {type}Benutzer gefunden',
  'admin.users.noUsersExist': 'Keine {type}Benutzer vorhanden',
  'admin.users.tryOtherSearch': 'Versuchen Sie einen anderen Suchbegriff.',
  'admin.users.createFirstLocal': 'Erstellen Sie den ersten Systembenutzer, um mit der Verwaltung zu beginnen',
  'admin.users.createFirstOci': 'Erstellen Sie den ersten OCI-Benutzer für die SAP-Integration',
  'admin.users.roleAdmin': 'Administrator',
  'admin.users.roleSupervisor': 'Vorgesetzter',
  'admin.users.rolePurchaser': 'Einkäufer',
  'admin.users.newUser': 'Neuer Benutzer',
  'admin.users.editUser': 'Benutzer bearbeiten',
  'admin.users.changePassword': 'Passwort ändern',
  'admin.users.deleteLocalUser': 'Benutzer löschen',
  'admin.users.editOci': 'OCI-Benutzer bearbeiten',
  'admin.users.deleteOci': 'OCI-Benutzer löschen',
  'admin.users.deleted': 'Benutzer erfolgreich gelöscht',
  'admin.users.created': 'Erstellt:',

  // ==================== ADMIN USER FORM ====================
  'admin.userForm.editTitle': 'Benutzer bearbeiten',
  'admin.userForm.createTitle': 'Neuen Benutzer anlegen',
  'admin.userForm.editSubtitle': 'Ändern Sie die Benutzerdaten und Berechtigungen',
  'admin.userForm.createSubtitle': 'Erstellen Sie einen neuen Systembenutzer',
  'admin.userForm.username': 'Benutzername *',
  'admin.userForm.usernameReadonly': 'Der Benutzername kann nicht geändert werden',
  'admin.userForm.email': 'E-Mail *',
  'admin.userForm.firstName': 'Vorname',
  'admin.userForm.lastName': 'Nachname',
  'admin.userForm.department': 'Abteilung',
  'admin.userForm.costCenter': 'Kostenstelle',
  'admin.userForm.plant': 'Werk',
  'admin.userForm.purchasingOrg': 'Einkäuferorganisation',
  'admin.userForm.sapUser': 'SAP-Benutzer',
  'admin.userForm.purchasingGroup': 'Einkäufergruppe',
  'admin.userForm.requester': 'Anforderer',
  'admin.userForm.role': 'Rolle',
  'admin.userForm.rolePurchaser': 'Einkäufer',
  'admin.userForm.roleSupervisor': 'Vorgesetzter',
  'admin.userForm.roleAdmin': 'Administrator',
  'admin.userForm.isActive': 'Benutzer ist aktiv',
  'admin.userForm.changePassword': 'Passwort ändern (optional)',
  'admin.userForm.setPassword': 'Passwort festlegen',
  'admin.userForm.newPassword': 'Neues Passwort',
  'admin.userForm.passwordRequired': 'Passwort *',
  'admin.userForm.confirmPassword': 'Passwort bestätigen',
  'admin.userForm.permissionProfiles': 'Berechtigungsprofile',
  'admin.userForm.profilesHint': 'Zugewiesene Profile bestimmen die Berechtigungen des Benutzers',
  'admin.userForm.noProfile': 'Kein Profil zugewiesen - der Benutzer hat nur Basis-Berechtigungen',
  'admin.userForm.usernameRequired': 'Benutzername ist erforderlich',
  'admin.userForm.emailRequired': 'E-Mail ist erforderlich',
  'admin.userForm.passwordMismatch': 'Passwörter stimmen nicht überein',
  'admin.userForm.passwordMinLength': 'Das Passwort muss mindestens 6 Zeichen lang sein',
  'admin.userForm.settingsLoadError': 'Fehler beim Laden der Einstellungen',
  'admin.userForm.createError': 'Fehler beim Erstellen des Benutzers',
  'admin.userForm.updateError': 'Fehler beim Aktualisieren des Benutzers',
  'admin.userForm.created': 'Benutzer erfolgreich erstellt!',
  'admin.userForm.updated': 'Benutzer erfolgreich aktualisiert!',

  // ==================== ADMIN OCI USER FORM ====================
  'admin.ociForm.editTitle': 'OCI-Benutzer bearbeiten',
  'admin.ociForm.createTitle': 'Neuen OCI-Benutzer erstellen',
  'admin.ociForm.username': 'Benutzername *',
  'admin.ociForm.password': 'Passwort * (Klartext für SAP)',
  'admin.ociForm.passwordHint': 'Passwort im Klartext für OCI',
  'admin.ociForm.email': 'E-Mail',
  'admin.ociForm.company': 'Firma',
  'admin.ociForm.isActive': 'Benutzer ist aktiv',

  // ==================== ADMIN DELETE CONFIRMATION ====================
  'admin.deleteUser.title': 'Benutzer löschen',
  'admin.deleteUser.confirm': 'Sind Sie sicher, dass Sie den {type}Benutzer "{username}" löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',

  // ==================== ADMIN OCI USER HOOK ====================
  'admin.ociHook.loadError': 'Fehler beim Laden der OCI-Benutzer: {error}',
  'admin.ociHook.credentialsRequired': 'Benutzername und Passwort sind erforderlich',
  'admin.ociHook.created': 'OCI-Benutzer erfolgreich erstellt',
  'admin.ociHook.updated': 'OCI-Benutzer erfolgreich aktualisiert',
  'admin.ociHook.deleteError': 'Fehler beim Löschen des OCI-Benutzers',
  'admin.ociHook.deleted': 'OCI-Benutzer erfolgreich gelöscht',

  // ==================== ADMIN OCI SHOP MANAGEMENT ====================
  'admin.ociShops.title': 'OCI-Shop Verwaltung',
  'admin.ociShops.subtitle': 'Verwalten Sie externe OCI-kompatible Online-Kataloge',
  'admin.ociShops.newShop': 'Neuer OCI-Shop',
  'admin.ociShops.urlConfigured': 'URL konfiguriert',
  'admin.ociShops.credentialsConfigured': 'Anmeldedaten: Konfiguriert',
  'admin.ociShops.credentialsNotConfigured': 'Anmeldedaten: Nicht konfiguriert',
  'admin.ociShops.empty': 'Keine OCI-Shops konfiguriert',
  'admin.ociShops.emptyDesc': 'Erstellen Sie Ihren ersten OCI-Shop, um externe Kataloge zu integrieren',
  'admin.ociShops.createFirst': 'Ersten OCI-Shop erstellen',

  // ==================== ADMIN OCI SHOP EDITOR ====================
  'admin.shopEditor.editTitle': 'Shop bearbeiten',
  'admin.shopEditor.createTitle': 'Neuen Shop hinzufügen',
  'admin.shopEditor.subtitle': 'OCI-Shop konfigurieren und verwalten',
  'admin.shopEditor.name': 'Shop-Name',
  'admin.shopEditor.supplier': 'Anbieter',
  'admin.shopEditor.url': 'OCI-URL',
  'admin.shopEditor.description': 'Beschreibung',
  'admin.shopEditor.category': 'Kategorie',
  'admin.shopEditor.categoryPlaceholder': 'z.B. Büromaterial',
  'admin.shopEditor.username': 'Benutzername',
  'admin.shopEditor.password': 'Passwort',
  'admin.shopEditor.credentialsUnchanged': 'Credentials bleiben unverändert (leer lassen)',
  'admin.shopEditor.credentialsHint': 'Leer lassen, um bestehende Anmeldedaten beizubehalten',
  'admin.shopEditor.urlParams': 'OCI-URL-Parameter',
  'admin.shopEditor.urlParamsHint': 'Konfigurieren Sie die URL-Parameter für die OCI-Integration',
  'admin.shopEditor.manageParams': 'Parameter verwalten',
  'admin.shopEditor.isActive': 'Shop ist aktiv',

  // ==================== ADMIN OCI PARAMETER EDITOR ====================
  'admin.ociParams.title': 'OCI-Parameter verwalten',
  'admin.ociParams.subtitle': 'URL-Parameter konfigurieren und per Drag & Drop sortieren',
  'admin.ociParams.addParam': 'Parameter hinzufügen',
  'admin.ociParams.createDefaults': 'Standard-Parameter erstellen',
  'admin.ociParams.defaultsCreated': 'Standard-Parameter wurden erfolgreich erstellt!',
  'admin.ociParams.defaultsError': 'Fehler beim Erstellen der Standard-Parameter: {error}',
  'admin.ociParams.empty': 'Keine Parameter konfiguriert',
  'admin.ociParams.emptyHint': 'Erstellen Sie Standard-Parameter oder fügen Sie manuell Parameter hinzu.',
  'admin.ociParams.paramKey': 'Parameter-Schlüssel',
  'admin.ociParams.paramValue': 'Wert',
  'admin.ociParams.paramType': 'Typ',
  'admin.ociParams.required': 'Erforderlich',
  'admin.ociParams.keyRequired': 'Parameter {index}: Schlüssel ist erforderlich',
  'admin.ociParams.saved': 'Parameter erfolgreich gespeichert!',
  'admin.ociParams.saveError': 'Fehler beim Speichern der Parameter: {error}',
  'admin.ociParams.parameter': 'Parameter',
  'admin.ociParams.dragDrop': 'Drag & Drop zum Sortieren',
  'admin.ociParams.unsavedChanges': 'Ungespeicherte Änderungen',
  'admin.ociParams.deleteSave': 'Löschen speichern',

  // ==================== ADMIN INTERNAL SHOP MANAGEMENT ====================
  'admin.internalShops.title': 'Interne Shop Verwaltung',
  'admin.internalShops.subtitle': 'Verwalten Sie eigene Produktkataloge und interne Shops',
  'admin.internalShops.newShop': 'Neuer interner Shop',
  'admin.internalShops.loadError': 'Fehler beim Laden der internen Shops',
  'admin.internalShops.saved': 'Shop erfolgreich erstellt!',
  'admin.internalShops.updated': 'Shop erfolgreich aktualisiert!',
  'admin.internalShops.saveError': 'Fehler beim Speichern des Shops: {error}',
  'admin.internalShops.deleted': 'Shop erfolgreich gelöscht!',
  'admin.internalShops.deleteError': 'Fehler beim Löschen des Shops',
  'admin.internalShops.loading': 'Interne Shops werden geladen...',
  'admin.internalShops.empty': 'Keine internen Shops',
  'admin.internalShops.emptyDesc': 'Erstellen Sie Ihren ersten internen Shop mit eigenen Produktkatalogen',
  'admin.internalShops.createFirst': 'Ersten Shop erstellen',
  'admin.internalShops.internalCatalog': 'Interner Katalog',
  'admin.internalShops.deleteShop': 'Shop löschen',

  // ==================== ADMIN INTERNAL SHOP FORM ====================
  'admin.shopForm.editTitle': 'Internen Shop bearbeiten',
  'admin.shopForm.createTitle': 'Neuen internen Shop erstellen',
  'admin.shopForm.subtitle': 'Konfigurieren Sie Ihren eigenen Produktkatalog',
  'admin.shopForm.name': 'Shop-Name *',
  'admin.shopForm.nameRequired': 'Shop-Name ist erforderlich',
  'admin.shopForm.category': 'Kategorie',
  'admin.shopForm.description': 'Beschreibung',
  'admin.shopForm.icon': 'Shop-Icon',
  'admin.shopForm.selectIcon': 'Icon auswählen',
  'admin.shopForm.iconHint': 'Klicken Sie auf "Icon auswählen", um ein passendes Emoji für Ihren Shop zu wählen',
  'admin.shopForm.isActive': 'Shop ist aktiv und für Benutzer sichtbar',
  'admin.shopForm.namePlaceholder': 'z.B. Büromaterial Shop',
  'admin.shopForm.categoryPlaceholder': 'z.B. Büromaterial',
  'admin.shopForm.descriptionPlaceholder': 'Kurze Beschreibung des Shops',

  // ==================== ADMIN INTERNAL SHOP DELETE MODAL ====================
  'admin.shopDelete.title': 'Shop löschen',
  'admin.shopDelete.subtitle': 'Diese Aktion kann nicht rückgängig gemacht werden',
  'admin.shopDelete.confirm': 'Sind Sie sicher, dass Sie den Shop {name} löschen möchten? Alle zugehörigen Produkte werden ebenfalls entfernt.',

  // ==================== ADMIN PRODUCT MANAGEMENT ====================
  'admin.products.title': 'Produkte verwalten',
  'admin.products.backToShops': 'Zurück zur Shop-Verwaltung',
  'admin.products.newProduct': 'Neues Produkt',
  'admin.products.loadError': 'Fehler beim Laden der Produkte',
  'admin.products.saved': 'Produkt erfolgreich erstellt!',
  'admin.products.updated': 'Produkt erfolgreich aktualisiert!',
  'admin.products.saveError': 'Fehler beim Speichern des Produkts: {error}',
  'admin.products.deleted': 'Produkt erfolgreich gelöscht!',
  'admin.products.deleteError': 'Fehler beim Löschen des Produkts',
  'admin.products.deleteConfirm': 'Sind Sie sicher, dass Sie das Produkt "{name}" löschen möchten?',
  'admin.products.search': 'Produkte suchen...',
  'admin.products.allCategories': 'Alle Kategorien',
  'admin.products.filterCategory': 'Kategorie',
  'admin.products.filterStatus': 'Status',
  'admin.products.filterManufacturer': 'Hersteller',
  'admin.products.filterSource': 'Quelle',
  'admin.products.statusActive': 'Aktiv',
  'admin.products.statusInactive': 'Inaktiv',
  'admin.products.sourceSap': 'SAP',
  'admin.products.sourceInternal': 'Intern',
  'admin.products.loading': 'Produkte werden geladen...',
  'admin.products.empty': 'Keine Produkte',
  'admin.products.emptyFiltered': 'Keine passenden Produkte',
  'admin.products.createFirst': 'Erstellen Sie Ihr erstes Produkt für diesen internen Shop.',
  'admin.products.changeFilter': 'Ändern Sie Ihre Suchkriterien oder Filter.',
  'admin.products.colProduct': 'Produkt',
  'admin.products.colCategory': 'Kategorie',
  'admin.products.colPrice': 'Preis',
  'admin.products.colStatus': 'Status',
  'admin.products.colStock': 'Lager',
  'admin.products.colActions': 'Aktionen',
  'admin.products.unlimited': 'Unbegrenzt',

  // ==================== ADMIN PRODUCT FORM ====================
  'admin.productForm.editTitle': 'Produkt bearbeiten',
  'admin.productForm.createTitle': 'Neues Produkt erstellen',
  'admin.productForm.internalShop': 'Interner Shop',
  'admin.productForm.sapReadOnlyHint': 'Aus SAP — schreibgeschützt. Stammdatenpflege erfolgt in SAP (MM02). Nur der Status kann hier geändert werden.',
  'admin.productForm.sapSection': 'SAP-Identifikation',
  'admin.productForm.baseSection': 'Grunddaten',
  'admin.productForm.textsSection': 'Mehrsprachige Texte (MAKT)',
  'admin.productForm.stockSection': 'Lagerbestände (MARD)',
  'admin.productForm.sourcesSection': 'Bezugsquellen',
  'admin.productForm.sources.title': 'Bezugsquellen',
  'admin.productForm.sources.vendor': 'Lieferant (LIFNR)',
  'admin.productForm.sources.vendorName': 'Lieferantenname',
  'admin.productForm.sources.vendorMaterialNo': 'Lief.-Materialnr.',
  'admin.productForm.sources.netPrice': 'Nettopreis',
  'admin.productForm.sources.priceUnit': 'Preiseinheit',
  'admin.productForm.sources.orderUnit': 'Bestelleinheit',
  'admin.productForm.sources.deliveryTime': 'Lieferzeit (Tage)',
  'admin.productForm.sources.isPrimary': 'Primär',
  'admin.productForm.sources.addRow': 'Bezugsquelle hinzufügen',
  'admin.productForm.sources.removeRow': 'Zeile entfernen',
  'admin.productForm.sources.empty': 'Noch keine Bezugsquellen hinterlegt.',
  'admin.productForm.sources.scaleTitle': 'Staffelpreise',
  'admin.productForm.sources.scaleMinQty': 'Ab Menge',
  'admin.productForm.sources.scaleAmount': 'Preis',
  'admin.productForm.sources.scaleAddRow': 'Staffel hinzufügen',
  'admin.productForm.sources.scaleRemoveRow': 'Staffel entfernen',
  'admin.productForm.ean': 'EAN / GTIN',
  'admin.productForm.priceUnit': 'Preiseinheit (PEINH)',
  'admin.productForm.materialType': 'Materialart (MTART)',
  'admin.productForm.materialTypeNone': 'Keine Angabe',
  'admin.productForm.materialStatus': 'Materialstatus',
  'admin.productForm.statusActive': 'Aktiv',
  'admin.productForm.statusBlocked': 'Gesperrt',
  'admin.productForm.statusDiscontinued': 'Auslauf',
  'admin.productForm.grossWeight': 'Bruttogewicht',
  'admin.productForm.netWeight': 'Nettogewicht',
  'admin.productForm.weightUnit': 'Gewichtseinheit',
  'admin.productForm.sizeText': 'Größentext',
  'admin.productForm.profitCenter': 'Profit-Center',
  'admin.productForm.texts.addLang': 'Sprache hinzufügen',
  'admin.productForm.texts.removeLang': 'Sprache entfernen',
  'admin.productForm.texts.name': 'Name',
  'admin.productForm.texts.namePlaceholder': 'Produktname in dieser Sprache',
  'admin.productForm.texts.description': 'Beschreibung',
  'admin.productForm.texts.descriptionPlaceholder': 'Produktbeschreibung in dieser Sprache',
  'admin.productForm.stock.plant': 'Werk',
  'admin.productForm.stock.storageLocation': 'Lagerort',
  'admin.productForm.stock.type': 'Bestandsart',
  'admin.productForm.stock.typeOwn': 'Eigen',
  'admin.productForm.stock.typeVendorConsignment': 'Konsignation',
  'admin.productForm.stock.typeAtVendor': 'Beim Lieferanten',
  'admin.productForm.stock.vendor': 'Lieferant (LIFNR)',
  'admin.productForm.stock.qty': 'Menge',
  'admin.productForm.stock.status': 'Status',
  'admin.productForm.stock.addRow': 'Lagerort hinzufügen',
  'admin.productForm.stock.removeRow': 'Zeile entfernen',
  'admin.productForm.stock.empty': 'Noch keine Lagerorte hinterlegt.',
  'admin.productForm.name': 'Produktname',
  'admin.productForm.nameRequired': 'Produktname ist erforderlich',
  'admin.productForm.sku': 'SAP Nummer / Artikelnummer',
  'admin.productForm.description': 'Beschreibung',
  'admin.productForm.price': 'Preis',
  'admin.productForm.priceRequired': 'Gültiger Preis ist erforderlich',
  'admin.productForm.currency': 'Währung',
  'admin.productForm.unit': 'Einheit',
  'admin.productForm.productGroup': 'Warengruppe',
  'admin.productForm.productGroupPlaceholder': 'z.B. Büromaterial, IT-Equipment',
  'admin.productForm.supplierArtNo': 'Lieferanten-Artikelnummer',
  'admin.productForm.preferredVendor': 'Wunschlieferant',
  'admin.productForm.fixedVendor': 'Fester Lieferant',
  'admin.productForm.costCenter': 'Kostenstelle',
  'admin.productForm.purchasingOrg': 'Einkaufsorganisation',
  'admin.productForm.plant': 'Werk',
  'admin.productForm.stock': 'Lagerbestand',
  'admin.productForm.stockSapPending': '(SAP-Integration ausstehend)',
  'admin.productForm.stockSapSync': 'Wird über SAP synchronisiert',
  'admin.productForm.minOrderQuantity': 'Mindestbestellmenge',
  'admin.productForm.imageUrl': 'Bild-URL (optional)',
  'admin.productForm.isActive': 'Produkt ist aktiv und sichtbar',
  'admin.productForm.detailsSection': 'Produktdetails (für Detailseite)',
  'admin.productForm.manufacturer': 'Hersteller',
  'admin.productForm.manufacturerPartNo': 'Herstellerteilenr.',
  'admin.productForm.purchasingGroup': 'Einkäufergruppe',
  'admin.productForm.plannedDeliveryTime': 'Plan-Lieferzeit',
  'admin.productForm.priceSource': 'Preisquelle',
  'admin.productForm.priceSourceNone': 'Keine Angabe',
  'admin.productForm.priceSourceContract': 'Kontraktpreis',
  'admin.productForm.priceSourceInforecordPlant': 'Infosatz werksspez.',
  'admin.productForm.priceSourceInforecordGeneral': 'Infosatz allgemein',
  'admin.productForm.priceSourceEstimate': 'Schätzpreis',
  'admin.productForm.priceSourceInternal': 'Interner Shop-Preis',
  'admin.productForm.technicalAttributes': 'Technische Attribute',
  'admin.productForm.priceScales': 'Preisstaffeln',
  'admin.productForm.contractData': 'Kontraktdaten',
  'admin.productForm.documents': 'Dokumente',
  'admin.productForm.compliance': 'Compliance / Normen',
  // F7: JSON-Tabellen-Editor
  'admin.jsonEditor.addRow': '+ Zeile',
  'admin.jsonEditor.removeRow': 'Zeile entfernen',
  'admin.jsonEditor.empty': 'Noch keine Einträge — „+ Zeile" zum Hinzufügen.',
  'admin.jsonEditor.attrLabel': 'Merkmal',
  'admin.jsonEditor.attrValue': 'Wert',
  'admin.jsonEditor.attrUnit': 'Einheit',
  'admin.jsonEditor.attrGroup': 'Gruppe',
  'admin.jsonEditor.scaleQty': 'ab Menge',
  'admin.jsonEditor.scalePrice': 'Preis',
  'admin.jsonEditor.docType': 'Typ',
  'admin.jsonEditor.docTitle': 'Titel',
  'admin.jsonEditor.docFormat': 'Format',
  'admin.jsonEditor.docUrl': 'URL',
  'admin.jsonEditor.compLabel': 'Norm',
  'admin.jsonEditor.contractExists': 'Kontrakt vorhanden',
  'admin.jsonEditor.contractNumber': 'Kontraktnummer',
  'admin.jsonEditor.contractItem': 'Position',
  'admin.jsonEditor.contractType': 'Kontraktart',
  'admin.jsonEditor.contractValidFrom': 'Gültig von',
  'admin.jsonEditor.contractValidTo': 'Gültig bis',
  'admin.jsonEditor.contractTargetQty': 'Zielmenge',
  'admin.jsonEditor.contractTargetValue': 'Zielwert',
  'admin.jsonEditor.contractPrice': 'Kontraktpreis',
  'admin.productForm.attributes.title': 'Technische Merkmale',
  'admin.productForm.attributes.label': 'Bezeichnung',
  'admin.productForm.attributes.value': 'Wert',
  'admin.productForm.attributes.unit': 'Einheit',
  'admin.productForm.attributes.charName': 'Techn. Name',
  'admin.productForm.attributes.addRow': 'Merkmal hinzufügen',
  'admin.productForm.attributes.removeRow': 'Zeile entfernen',
  'admin.productForm.attributes.empty': 'Noch keine technischen Merkmale hinterlegt.',
};

export default admin;
